define('app',[
    'jquery',
    'underscore',
    'event-manager',
    'pym',
    'lib',
    'lazy-loader',
    'lunch',
    'bottomboard',
    'meetrics',
    'job-carousel-tracking'
], function($, _, eventManager, Pym, lib, LazyLoader, lunch, bottomboard, loadMeetrics, jobbCarouselTracker) {
    'use strict';

    var App = function() {
        function lazyload() {
            if (lazyElements && lazyElements.detach) {
                lazyElements.detach();
            }

            if (lazyImages && lazyImages.detach) {
                lazyImages.detach();
            }

            if (lazyEmbed && lazyEmbed.detach) {
                lazyEmbed.detach();
            }

            var lazyElements = new LazyLoader({
                on: $('.lazy-element, .lazy-front').toArray(),
                threshold: 800,
                aboveTheFold: true,
            });

            var lazyImages = new LazyLoader({
                on: $('.lazy-image').toArray(),
                threshold: 800,
                callback: function(element){
                    var src = element.getAttribute('data-original');
                    element.setAttribute('src', src);
                }
            });

            var lazyEmbed = new LazyLoader({
                on: $('.lazy-embed').toArray(),
                threshold: 100,
                callback: function(element){
                    var src = element.getAttribute('data-original');

                    if (element.getAttribute('data-autosize')) {
                        var id = element.getAttribute('id');
                        new Pym.Parent(id, src, {});

                        if (id === 'job-carousel') {
                            jobbCarouselTracker();
                        }
                    } else {
                        element.setAttribute('src', src);
                    }
                }
            });
        }

        if (lib.isApp()) {
            document.cookie = 'e24app=true; path=/; domain=.e24.no;';
        }

        eventManager.on('domready e24-find-lazy-loads', lazyload);

        eventManager.once('lazy-bunnlinjen-loaded', lunch.init);

        eventManager.once('lazy-bottomboard-loaded', function() {
            bottomboard.init();
        });

        window.addEventListener('load', setTimeout.bind(null, function() {
            loadMeetrics();
        }, 10));
    };

    return App();
});

